import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import clsx from 'clsx'
import CTA from '@/lib/CTA'

const TextCtaItem = ({ heading, _rawRichtext, cta }) => (
	<article className="flex flex-col justify-around text-lg richtext">
		<HTag className="h2" {...heading} />
		<Richtext raw={_rawRichtext} />
		<p><CTA className="text-center text-base" {...cta} /></p>
	</article>
)

const TextCtaSection = ({ heading, _rawRichtext, accent, items }) => {
	const style =
		accent === '#FFC28B' ? 'bg-orange-light' :
		accent === '#FFC42F' ? 'bg-sunshine' :
		accent === '#E4F9FA' ? 'bg-light-blue' :
		accent === '#F7E9D4' ? 'bg-tan text-orange' :
		accent === '#0F2938' ? 'bg-grounding-navy text-white' :
		accent === '#7FC7C5' ? 'bg-caribbean text-white' :
		null

	return (
		<section className={clsx('relative z-10', style)}>
			<div className="section-lg">
				<header className="richtext text-center text-lg">
					<HTag className="h1" {...heading} />
					<Richtext raw={_rawRichtext} />
				</header>

				<div className="mt-12 grid md:grid-cols-2 gap-8 md:gap-20">
					{items?.map((item, key) => (
						<TextCtaItem {...item} key={key} />
					))}
				</div>
			</div>
		</section>
	)
}

export default TextCtaSection
